import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    getFilterOptionsBy(ctx, q) {
      return new Promise((resolve, reject) => {
        axios.get('filters/getFilterBy', { params: q })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
